<script>
	import Face from "./Face.svelte";
	export let bio;
</script>

<div class="about-container" id="about">
	<Face/>
	<p>
		{@html bio}
	</p>
</div>

<style>
	.about-container {
		padding: 100px;
		padding-top: 150px;
		display: flex;
		flex-direction: column;
		justify-items: center;
		align-items: center;
	}

	.about-container p {
		max-width: 800px;
		min-width: 275px;
		user-select: none;
	}
</style>
